import i18n from "@lib/i18n";

export const getAssetMultiCreateRequestMessage = (props) => {
    const message = i18n.t(
        `common::msg::Asset '{{name}}' and {{count}} other assets have been requested.`,
        `Asset '{{name}}' and {{count}} other assets have been requested.`,
        {
            name: props?.name,
            count: props?.count,
        },
    );

    return message;
};

export const getAssetCreateRequestMessage = (props) => {
    const message = i18n.t(
        `common::msg::Asset '{{name}}' has been requested.`,
        `Asset '{{name}}' has been requested.`,
        {
            name: props?.name,
        },
    );

    return message;
};

export const getAssetUpdatePreviewMessage = (props) => {
    const message = i18n.t(
        `common::msg::A preview setting of '{{name}}' have been requested.`,
        `A preview setting of '{{name}}' have been requested.`,
        {
            name: props?.name,
        },
    );

    return message;
};

export const getVideoCreateRequestMessage = (props) => {
    const message = i18n.t(
        `common::msg::Video '{{name}}' has been requested.`,
        `Video '{{name}}' has been requested.`,
        {
            name: props?.name,
        },
    );

    return message;
};

export const getRequestCreateRequestMessage = (props) => {
    const message = i18n.t(
        `common::msg::Asset '{{name}}' has been requested.`,
        `Asset '{{name}}' has been requested.`,
        {
            name: props?.name,
        },
    );

    return message;
};
